import AuthorizeClient from './components/root';
import AuthorizeHeader from './components/authorize-header';
import rootReducer from './state/reducer';
import { middlewareClientMapping } from 'shared/app/utils/middleware-mapping';

const { verifyUserMiddleware } = middlewareClientMapping;

export default {
  name: 'oauthAuthorize',
  reducer: rootReducer,
  routes: {
    '/oauth/authorize': {
      headerCrate: AuthorizeHeader,
      contentCrate: AuthorizeClient,
      hideGlobalNav: true,
      applyMiddleware: [verifyUserMiddleware],
    },
  },
};
